<!-- 払い戻し完了ダイアログ-->
<template>
  <ItemDialog ref="couponSuccess" imageType="done">
    <template v-slot:content-area>
      <h2>クーポンを使用して<br />チケットの取得が完了しました</h2>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="OK"
        actionType="btn-primary"
        @clicked="returnNativeAppMyticketPage"
      />
    </template>
  </ItemDialog>
</template>

<script>
export default {
  name: "DialogCouponSuccess",
  methods: {
    async openDialog() {
      this.$refs.couponSuccess.open();
    },
    async closeDialog() {
      this.$refs.couponSuccess.close();
    },
  },
};
</script>
